import React, {useRef, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";


const CarouselWrapper = styled.div`
    width: 100%;
    overflow: hidden;
    position: relative;
`;

const HorizontalContainer = styled.div`
    display: flex;
    width: 100%;
    transition: transform 0.5s ease-in-out;
`;

const Slide = styled.div`
    width: 100%;
    flex-shrink: 0;
    flex-grow: 1;
`;

const Carousel = ({currentIndex, children}) => {
    const containerRef = useRef(null);
    return (
        <CarouselWrapper
            className="carousel-wrapper"
            ref={containerRef}
        >
            <HorizontalContainer
                style={{
                    transform: `translateX(${100 * currentIndex}%)`,
                }}
            >
                {React.Children.map(children, (child, index) => (
                    <Slide
                        key={index}
                    >
                        {child}
                    </Slide>
                ))}
            </HorizontalContainer>
        </CarouselWrapper>
    );
};

Carousel.propTypes = {
    currentIndex: PropTypes.number.isRequired,
};

export default Carousel;
